const initialState = {
    products: [],
    isProductPage: true

};

export default initialState;
